import { Stack, styled } from '@mui/material';

const StyledStack = styled(Stack)(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  border: '1px solid',
  borderRadius: theme.shape.borderRadius,
  borderColor: (theme.vars || theme).palette.borderColor,
}));
export default StyledStack;
